<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-button @click="addNewUser" icon="Plus" type="primary" style="margin-right: 10px;">新建用户</el-button>
			<el-input
			  v-model="key"
			  placeholder="请输入搜索关键词"
			  class="input-with-select"
			>
			  <template #prepend>
			    <el-select v-model="type" placeholder="条件类型" style="width: 115px">
			      <el-option label="账号" value="username" />
				  <el-option label="姓名" value="nickname" />
			    </el-select>
			  </template>
			  <template #append>
			    <el-button @click="fetchOrders" icon="Search" />
			  </template>
			</el-input>
		</div>
	</div>
	<el-table :data="tableData" style="width: 100%" height="680">
	    <el-table-column fixed prop="username" label="账号" width="320" />
	    <el-table-column prop="nickname" label="名称" width="300" />
		<el-table-column prop="tenant_key" label="租户编号" width="320" />
		<el-table-column prop="statusSpan" label="状态" width="320" >
			<template #default="scope">
				<el-tag :type="scope.row.statusSpan === '在职' ? 'primary' : 'success'" disable-transitions>{{ scope.row.statusSpan }}</el-tag>
			</template>
		</el-table-column>
	    <el-table-column fixed="right" label="操作" width="*">
	      <template #default="scope">
			<el-button v-if="scope.row.status===0" link type="primary" size="small" @click="fireData(scope.row)">离职</el-button>
			<el-button v-if="scope.row.status===1" link type="primary" size="small" @click="hireData(scope.row)">返聘</el-button>
			<el-button v-if="scope.row.status===0" link type="primary" size="small" @click="modifyName(scope.row)">修改昵称</el-button>
			<el-button v-if="scope.row.status===0" link type="primary" size="small" @click="modifyPass(scope.row)">修改密码</el-button>
	      </template>
	    </el-table-column>
	</el-table>
	<div class="pagination-custom">
		<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
	</div>
	<el-dialog
	    v-model="bzDialogVisible"
	    title="修改昵称"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-input class="w-50 m-2" v-model="newNickName" />
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="bzDialogVisible = false">关闭</el-button>
		    <el-button type="primary" @click="saveNickName">保存</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
	    v-model="passDialogVisible"
	    title="修改密码"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-form
		    ref="ruleFormRef"
		    :model="sizeForm"
		    label-width="auto"
		    :label-position="labelPosition"
		    :size="size"
			:rules="rules"
		>
			<div style="display: flex;">
				<el-form-item label="当前密码" style="width: 96%;" prop="oldPassword">
				  <el-input v-model="sizeForm.oldPassword" class="w-50 m-2" type="password" placeholder="请输入当前密码" show-password  autocomplete="off"/>
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="新密码" style="width: 96%;" prop="password">
				  <el-input v-model="sizeForm.password" class="w-50 m-2" type="password" placeholder="请输入新密码" show-password  autocomplete="off"/>
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="确认密码" style="width: 96%;" prop="rpassword">
				  <el-input v-model="sizeForm.rpassword" class="w-50 m-2" type="password" placeholder="请确认密码" show-password autocomplete="off"/>
				</el-form-item>
			</div>
		</el-form>
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="passDialogVisible = false">关闭</el-button>
		    <el-button type="primary" @click="saveNewPass">保存</el-button>
		  </span>
		</template>
	</el-dialog>
</template>

<script setup>
	import { ref,provide,inject,onMounted } from 'vue';
	import axios from 'axios';
	import { useMemberStore } from '../../stores';
	import { ElMessage } from 'element-plus'
	import { useRouter } from 'vue-router'
	const userStore = useMemberStore();
	const size = ref('default')
	const labelPosition = ref('right')
	const ruleFormRef = ref(null)
	const newNickName = ref('')
	const validateOldPass = async(rule, value, callback) => {
	  if (value !== '') {
		//查询接口 账号是否已被占用
		const response = await axios.post('/hrm/user/verifyPass', {
		  billid:billid.value,
		  password:sizeForm.value.oldPassword
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===1){
			callback(new Error(response.data.msg))
		}else if(response.data.status===0&&!response.data.msg){
			callback(new Error("原密码不正确。"))
		}
	   } else {
			callback()
	  }
	}
	const validatePass = (rule, value, callback) => {
	  if (value === '') {
	    callback(new Error('请输入密码'))
	  } else {
	    callback()
	  }
	}
	const validatePass2 = (rule, value, callback) => {
	  if (value === '') {
	    callback(new Error('请再次输入密码'))
	  } else if (value !== sizeForm.value.password) {
	    callback(new Error("2次输入密码不一致!"))
	  } else {
	    callback()
	  }
	}
	const rules = ref({
	  password: [{ validator: validatePass, trigger: 'blur' }],
	  rpassword: [{ validator: validatePass2, trigger: 'blur' }],
	  oldPassword:[{ validator: validateOldPass, trigger: 'blur' }],
	})
	const bzDialogVisible = ref(false)
	const sizeForm = ref({
		oldPassword:'',
		password:'',
		rpassword:'',
	});
	
	const modifyName = async(e) =>{
		billid.value = e.id
		newNickName.value = e.nickname
		bzDialogVisible.value = true
	}
	const passDialogVisible = ref(false)
	const modifyPass = async(e) =>{
		billid.value = e.id
		passDialogVisible.value = true
	}
	const saveNickName = async() =>{
		const response = await axios.post('/hrm/user/modifyNickName', {
		  billid:billid.value,
		  nickname:newNickName.value
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage.success('修改成功!')
			bzDialogVisible.value = false
			fetchOrders()
		}
	}
	
	const saveNewPass=()=>{
		ruleFormRef.value.validate(async valid=>{
			if(valid){
				const response = await axios.post('/hrm/user/modifyPass', {
				  billid:billid.value,
				  password:sizeForm.value.password
				}, {
				  headers: {
					'Content-Type': 'application/json',
					Authorization: `${userStore.profile?.token}`,
				  }
				});
				if(response.data.status===0){
					ElMessage.success('修改成功!')
					sizeForm.value = {}
					passDialogVisible.value = false
				}
			}else{
				ElMessage.error('校验不通过!')
			}
		})
	}
	const pageNo = ref(1);
	const pageSize = ref(20);
	const total = ref(0);
	const searchType = ref(0);
	const key = ref('');
	const type = ref('');
	const tableData = ref([]);
	const billid = ref('');
	const router = useRouter();
	const addNewUser=()=>{
		router.push('/hrm/user-add'); 
	}
	provide('billid', billid);
	onMounted(async()=>{
		const response = await axios.post('/hrm/user/queryList', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	})
	const fetchOrders = async () => {
		searchType.value = 0;
		const response = await axios.post('/hrm/user/queryList', {
		  key: type.value,
		  value:key.value,
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	};
	const fireData = async(e)=>{
		const response = await axios.post('/hrm/user/modifyStatus', {
		  billid:e.id,
		  status:1
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '离职成功!',
				type: 'success',
			})
			fetchOrders()
		}
	}
	const hireData = async(e) =>{
		const response = await axios.post('/hrm/user/modifyStatus', {
		  billid:e.id,
		  status:0
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '返聘成功!',
				type: 'success',
			})
			fetchOrders()
		}
	}
	const changePageNo = (val) => {
		pageNo.value = val;
		fetchOrders();
	}
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.search-jsj-tatle{
		float: right;
		width: 50%;
		margin: 0 0 10px 0;
	}
	.dialog-cond-dt{
		margin: 0 0 0 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
</style>